<template>
  <b-modal
    :id="id"
    size="lg"
    :title="title"
    @ok="emitDelete"
  >
    <slot></slot>
    <template v-slot:modal-footer="{ ok, cancel }">
      <b-button @click="ok" variant="primary">
        Удалить
      </b-button>
      <b-button variant="outline-primary" @click="cancel">
        Отмена
      </b-button>
    </template>
  </b-modal>
</template>

<script>
export default {
  name: 'DeleteModal',
  props: {
    id: {
      type: String,
      default: 'deleteModalId'
    },
    title: {
      type: String,
      default: 'Подтверждение удаления'
    }
  },
  methods: {
    emitDelete() {
      this.$emit('delete')
    }
  }
}
</script>

<style scoped>

</style>
